import React, { Component } from 'react';
import HttpRunner from '../query';
import urlHandler from '../../../utils/urlHandler';
import perms from '../../../utils/permissions';
import examples from '../../../utils/examples';

class DocPersonEntity extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    componentDidMount() {
        this.setState({
            dynamicSample: perms.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENRICH)
        }) 
    }

    render() {
        return (
            <div className="bucket" id="top">
                <div>
                    <h3 id="person" className="heading-1">Person</h3>
                    <div className="description">
                        Persons are returned in a standardized format. A percentage, but not all, Persons
                        that are extracted are also disambiguated.
                    </div>

                    <div className="description">An extracted PERSON may be represented by the following attributes:</div>

                    <table className="table-wrapper">
                        <thead className="table-header">
                        <tr>
                            <th>Attribute </th>
                            <th>Meaning </th>
                            <th>Type </th>
                            <th>Constraints </th>
                            <th>Notes </th>
                        </tr>
                        </thead>
                        <tbody className="table-body">
                        <tr>
                            <td className="attribute">gender</td>
                            <td className="meaning">Gender</td>
                            <td className="type">String</td>
                            <td className="constraints">Optional</td>
                            <td className="notes">
                                F for female
                                M for male
                                U for indeterminate</td>
                        </tr>
                        <tr>
                            <td className="attribute">firstName</td>
                            <td className="meaning">First Name</td>
                            <td className="type">String</td>
                            <td className="constraints">Optional</td>
                            <td className="notes">
                                First Name of the extracted person
                            </td>
                        </tr>
                        <tr>
                            <td className="attribute">middleName</td>
                            <td className="meaning">Middle Name</td>
                            <td className="type">String</td>
                            <td className="constraints">Optional</td>
                            <td className="notes">
                                Middle Name of the extracted person
                            </td>
                        </tr>
                        <tr>
                            <td className="attribute">lastName</td>
                            <td className="meaning">Last Name</td>
                            <td className="type">String</td>
                            <td className="constraints">Optional</td>
                            <td className="notes">
                                Last Name of the extracted person
                            </td>
                        </tr>
                        <tr>
                            <td className="attribute">title</td>
                            <td className="meaning">Title of the person extracted</td>
                            <td className="type">String</td>
                            <td className="constraints">Optional</td>
                            <td className="notes"> Title of the extracted person (ex. Dr., Mr., etc.)</td>
                        </tr>
                        <tr>
                            <td className="attribute">suffix</td>
                            <td className="meaning">Generational suffix of the person extracted</td>
                            <td className="type">String</td>
                            <td className="constraints">Optional</td>
                            <td className="notes">
                                Suffix of the extracted person (ex. Jr, III, Sr, etc)
                            </td>
                        </tr>
                        <tr>
                            <td className="attribute">profSuffix</td>
                            <td className="meaning">Professional suffix of the person extracted</td>
                            <td className="type">String</td>
                            <td className="constraints">Optional</td>
                            <td className="notes"> Prof. suffix of the extracted person (ex. MD, ESQ, PhD, etc.)</td>
                        </tr>
                        <tr>
                            <td className="attribute">prefixDescription</td>
                            <td className="meaning">Additional text at the beginning of the person name extracted </td>
                            <td className="type">String</td>
                            <td className="constraints">Optional</td>
                            <td className="notes">Ex. District Court Chief
                            </td>
                        </tr>
                        <tr>
                            <td className="attribute">suffixDescription</td>
                            <td className="meaning">Additional text at the end of the person name extracted</td>
                            <td className="type">String</td>
                            <td className="constraints">Optional</td>
                            <td className="notes"> Ex. Director, Trustee, etc. </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="bucket">
                    <h4 id="dp" className="heading-3">Disambiguated Person</h4>
                    <div className="description">
                        A person that has been disambiguated will have a disambiguated object that contains the 
                        top disambiguated result. The result includes the disambiguation confidence score, the id of the
                        entity, and the official label of the entity. The entity id can be used in
                        a GET {urlHandler.API_ENDPOINT_V2_ENTITIES}/{'{'}entity_id{'}'} call to retrieve more
                        information about the person, as described above in the API section of this
                        document.
                    </div>
                </div>

                <h4 className="heading-2">Examples</h4>

                <div className="example-content">Extracted but not disambiguated persons : .show Dr. 
                    Richard Stevenson presented Mr. Jay X Smith with a diagnosis</div>
                <HttpRunner example="person1" 
                    query="enrich"
                    response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_PERSON1) : null}
                />
                <br/>
                <div className="example-content">...Contacts: The Centre for Drug Research and 
                    Development (CDRD) Barry Gee Director,</div>
                <HttpRunner example="person2" 
                    query="enrich"
                    response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_PERSON2) : null}
                />
                <br/>
                <div className="example-content">Disambiguated Person: Edward Snowden is "under the care 
                        of the Russian authorities" and can&apos;t leave Moscow&apos;s international airport 
                        without their consent...</div>
                <HttpRunner example="persond" 
                    query="enrich"
                    response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_PERSON3) : null}
                />
            </div>
        );
    }
}

export default DocPersonEntity;